var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapstroke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83241 2.40979L1.7979 1.49483C1.73533 1.48064 1.67578 1.5282 1.67578 1.59235V11.0901C1.67578 11.1354 1.70615 11.175 1.74984 11.1867L5.83241 12.2832M5.83241 2.40979V12.2832M5.83241 2.40979L10.1384 1.46713M5.83241 12.2832L10.1384 10.9684M10.1384 10.9684V1.46713M10.1384 10.9684L14.3152 12.2438C14.3795 12.2634 14.4444 12.2153 14.4444 12.1481V2.49026C14.4444 2.44328 14.4117 2.40263 14.3658 2.39258L10.1384 1.46713",
    stroke: "#164A1A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapstroke);
export default __webpack_public_path__ + "static/media/mapstroke.f8c7c8c08f92f431bfa9957cf4ccd3ed.svg";
export { ForwardRef as ReactComponent };